<template>
  <parallax class="section page-header header-filter" :style="headerStyle">
    <div class="container">
      <div class="md-layout">
        <div
          class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
        >
          <h1 class="title">Ferienhaus deBontje</h1>
          <h4>
            Diese nette Begrüßung werden Sie häufiger in der Region Greetsiel
            erleben. Die deBontje ist ein Ferienhaus im Norden Deutschlands und
            befindet sich im Urlaubsort an der ostfriesischen Nordseeküste
            Greetsiel - Krummhörn.
          </h4>
          <br />
          <md-button
            href="https://www.traum-ferienwohnungen.de/130633/"
            class="md-success md-lg"
            target="_blank"
            ><i class="fas fa-play"></i> Buchen</md-button
          >
        </div>
      </div>
    </div>
  </parallax>
</template>

<script>
export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/ferienhaus_debontje_greetsiel_garten_3.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>
